'use strict';

var react = require('@emotion/react');
var zIndex = require('../../../../constants/zIndex.cjs');

const coreActions = /*#__PURE__*/ react.css({
    padding: "8px 0",
    position: "relative",
    zIndex: zIndex.cardAction
}, "label:label-CoreActions-web-stylescoreActions", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2J1aWxkcy9kZXZlbG9wZXJzL2F2aWFyeS9wYWNrYWdlcy9hdmlhcnktd2ViL3NyYy9jb21wb25lbnRzL3BsYXRmb3JtL1Byb2R1Y3RDYXJkL0NvcmVBY3Rpb25zL0NvcmVBY3Rpb25zLndlYi5zdHlsZXMudHMiLCJzb3VyY2VzIjpbIi9idWlsZHMvZGV2ZWxvcGVycy9hdmlhcnkvcGFja2FnZXMvYXZpYXJ5LXdlYi9zcmMvY29tcG9uZW50cy9wbGF0Zm9ybS9Qcm9kdWN0Q2FyZC9Db3JlQWN0aW9ucy9Db3JlQWN0aW9ucy53ZWIuc3R5bGVzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xuXG5pbXBvcnQgeyB6SW5kZXggfSBmcm9tIFwiI2NvbnN0YW50c1wiO1xuXG5leHBvcnQgY29uc3QgY29yZUFjdGlvbnMgPSBjc3Moe1xuICBwYWRkaW5nOiBcIjhweCAwXCIsXG4gIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gIHpJbmRleDogekluZGV4LmNhcmRBY3Rpb24sXG59KTtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJMkIifQ== */");

exports.coreActions = coreActions;
//# sourceMappingURL=CoreActions.web.styles.cjs.map
